import React from "react";
import SectionWithHeadings from "../section-with-headings/section-with-headings";
import { GridCardsProps } from "./grid-cards-types";
import { StyledGrid, GridContainer, EmptyGridMessageContainer } from "./style-component";
import EmojiLookDown from "@/assets/icons/emoji-look-down/emoji-look-down.svg"

export const GridCards = <T,>({
    items,
    title,
    renderItem,
    variant = 'default',
    gap
}: GridCardsProps<T>) => {
    return (
        <GridContainer>
            {title && (
                <SectionWithHeadings title={title} titleColor={"default"} style={{ marginBottom: "32px" }} />
            )}
            {Array.isArray(items) && items?.length > 0 ?
                <StyledGrid gap={gap} $variant={variant}>
                    {items?.map((item, index) => <React.Fragment key={0 + index}>{renderItem(item, index)}</React.Fragment>)}
                </StyledGrid> :
                <EmptyGridMessageContainer>
                    <img src={EmojiLookDown} alt="" />
                    <h3>Está un poco vacío por aquí...</h3>
                    <p>Participa en misiones para hacer crecer tu biblioteca.</p>
                </EmptyGridMessageContainer>
            }
        </GridContainer>
    );
};